import { setToken } from '@/utils/token';
import { setUser } from '@/utils/user';
import { formatDate } from '@/filters';

/**
 * 获取合并行数组
 * @param {Array} data 数据
 * @return {String} prop 属性
 * @return {Array} spanArr 合并行数组
 */
function getRowSpan(data, prop) {
  const spanArr = [];
  let pos = 0;
  data.forEach((item, index) => {
    if (index === 0) {
      spanArr.push(1);
      pos = 0;
    } else {
      if (data[index][prop] === data[index - 1][prop]) {
        spanArr[pos] += 1;
        spanArr.push(0);
      } else {
        spanArr.push(1);
        pos = index;
      }
    }
  });
  return spanArr;
}

/**
 * 获取IE10或以下版本
 * @return {Number} 版本号
 */
function getIeVer() {
  const reg = /MSIE\s+(\d+)/;
  const exec = reg.exec(navigator.userAgent);
  return exec ? exec[1] : 0;
}

/**
 * 通过key获取url的参数值
 * @param {String} key
 * @return url的参数值
 */
function getQueryString(key) {
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i');
  const value = window.location.search.substring(1).match(reg);
  return value != null ? decodeURIComponent(value[2]) : null;
}

/**
 * 登录成功提示并存储用户信息和身份凭证
 * @return {String} data 用户数据
 * @return {String} authorization 身份凭证
 */
function setUserInfo(data, authorization) {
  setToken(authorization);
  setUser(data);
}

/**
 * 浮点数高精度计算
 * @param {Number, String} num 数字
 * @param {Number} precision 精度
 * @return {Number} 不丢精度的数字
 */
const numberPrecision = (num, precision = 12) => {
  if (typeof num === 'string') {
    num = parseFloat(num);
  }
  return +parseFloat(num.toPrecision(precision));
};

/**
 * 计算相差毫秒数
 * @param {String} startDate 开始日期
 * @param {String} endDate 结束日期
 * @return {Number} 相差毫秒数
 */
const diffTime = (startDate, endDate) => {
  // 开始时间毫秒数
  const startTime = new Date(startDate).getTime();
  // 结束时间毫秒数
  const endTime = new Date(endDate).getTime();
  // 相差毫秒数
  return endTime - startTime;
};

/**
 * 获取指定日期上一天、下一天
 * @param {String|Object} date 指定日期
 * @param {Number} day 天数
 * @return {String} 日期
 */
const getNextDate = (date, day) => {
  const d = new Date(date);
  d.setDate(d.getDate() + day);
  return formatDate(d);
};

/**
 * 字符串拆分数组
 * @param {String} data 字符串数据
 * @return {Array} 拆分后的数组
 */
const split2Array = (data) => {
  if (data) {
    return data.split(',');
  }

  return [];
};

export {
  getRowSpan,
  getIeVer,
  getQueryString,
  setUserInfo,
  numberPrecision,
  diffTime,
  getNextDate,
  split2Array
};